<template>
  <div style="height: 100%; background: #F2F2F6">
         <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ name: 'Factory' }">生产配额</el-breadcrumb-item>
          <el-breadcrumb-item>分配额度</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row style="padding:30px 30px 0;color:#666666;font-size:16px ">
          基本信息
        </el-row>
          <el-divider></el-divider>
        <el-form
          :model="produce"
          :rules="rules"
          ref="customerForm"
          label-width="130px"
          label-position="right"
          style="padding-top:0px !important"
          size="mini"
        >
        <el-row>
          <el-col :span="6">
             <el-form-item label="用户名" prop="username">
            <el-input disabled v-model="produce.username" maxlength="20"></el-input>
          </el-form-item>
          </el-col>

          <el-col :span="6">
           <el-form-item label="名称" prop="name">
            <el-input v-model="produce.name" maxlength="20"></el-input>
          </el-form-item>
          </el-col>
              <el-col :span="6">
            <el-form-item>
            <el-button type="primary" size="small" @click="saveDealer()">保存</el-button>
          </el-form-item>
              </el-col>
             </el-row>

        </el-form>

    <el-tabs v-model="activeName" style="width:calc(100% - 60px);margin-left:30px;" >
    <el-tab-pane label="生产配额" name="first">
      <div style="height: 100%; background: #F2F2F6">
        <el-row>
          <el-select
         clearable
         filterable
         size="small"
          v-model="where.type">
            <el-option  v-for="t in alltype" :label="t.text" :value="t.value" :key="t.value">
            </el-option>
          </el-select>
          <el-button type="success" size="mini" @click="searchNumber()">查询</el-button>
          <el-button type="primary" size="mini" @click="newNum()">添加新配额</el-button>
          <el-button type="primary" size="mini" onclick="download('peitable','配额表')">导出</el-button>
          </el-row>
          <el-divider></el-divider>
        <el-table
          id="peitable"
          :data="numdata"
          ref="table"
          stripe
          border
          style="width:100%;border-radius: 0.625rem;font-size:12px"
           :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'line-height': '20px', padding: '8px', 'text-align': 'center' }"
        >
          <el-table-column
            type="index"
            label=""
            :index="indexMethod"
          ></el-table-column>
           <el-table-column prop="name" label="产品类型">
            </el-table-column>
            <el-table-column prop="start" label="起始编号" :width="150">
            </el-table-column>
            <el-table-column prop="end" label="结束编号" :width="150">
            </el-table-column>
            <el-table-column prop="current" label="下一个生产编号" :width="150">
            </el-table-column>
            <el-table-column label="使用量" :width="280">
              <template  slot-scope="scope">
                <el-progress :percentage="(scope.row.current-scope.row.start)/(scope.row.end-scope.row.start+1)*100"></el-progress>
              </template>
            </el-table-column>
            <el-table-column prop="createdtime" label="分配时间" >
            </el-table-column>
            <el-table-column prop="updatetime" label="最后生产时间">
            </el-table-column>
            <el-table-column prop="updatetime" label="预生成未使用数">
              <template  slot-scope="scope" >
              <span v-if=" ['VOD10000','VOD10001'].indexOf(scope.row.type)>=0"> {{ scope.row.reset||0 }}</span>
               <span v-else>--</span>
              </template>
            </el-table-column>
          <el-table-column label="操作" column-key="opt" :width="155">
            <template  slot-scope="scope" >
              <el-button v-if="['VOD10000','VOD10001'].indexOf(scope.row.type)>=0&&scope.row.current<=scope.row.end"
              size="mini"
                type="text"
                @click="ready(scope.row)"
                >预生成</el-button>
                <el-divider v-if="['VOD10000','VOD10001'].indexOf(scope.row.type)>=0&&scope.row.current<=scope.row.end" direction="vertical"></el-divider>
              <el-button
              size="mini"
                type="text"
                @click="deleteNum(scope.row)"
                >删除</el-button>
            </template>
          </el-table-column>
        </el-table>

    <el-row>
        <el-pagination
          background
          :page-sizes="[10, 15, 30, 50, 100]"
          :current-page="pageset.index"
          :page-size="pageset.size"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total,sizes,prev, pager, next"
          :total="totalsize"
          style="float: right; margin-top: 0.625rem;margin-bottom:10px"
        >
        </el-pagination>
    </el-row>
  </div>
    </el-tab-pane>
  </el-tabs>
  <el-dialog title="生产配额" :visible.sync="dialogFormVisible"  :close-on-click-modal="false">
  <el-form :model="num"
  ref="numForm"
          :rules="numrules">
    <el-form-item label="选择网关类型" prop="type" label-width="140px">
      <el-select
         clearable
         filterable
         size="small"
          v-model="num.type">
            <el-option  v-for="t in alltype" :label="t.text" :value="t.value" :key="t.value">
            </el-option>
          </el-select>
    </el-form-item>
    <el-form-item label="配额数量" prop="count" label-width="140px">
      <el-input-number v-model="num.count" :step="1" :min="1" :max="9999"></el-input-number>
    </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button @click="dialogFormVisible = false">取 消</el-button>
    <el-button type="primary" @click="saveNum()">确 定</el-button>
  </div>
</el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'CreateUser',
  data () {
    return {
      activeName: 'first',
      alltype: [{
        'text': '蜂巢大主机',
        'value': 'MSD2E000'
      },
      {
        'text': '精简小主机',
        'value': 'MSE1E000'
      },
      {
        'text': '全联供输配',
        'value': 'MTC1E000'
      },
      {
        'text': '全联供空调',
        'value': 'MFC1E000'
      },
      {
        'text': '4G主机标准版',
        'value': 'M4G20000'
      },
      {
        'text': '4G主机新风环控机',
        'value': 'MEC10000'
      },
      {
        'text': '4G主机AIO5专用',
        'value': 'MIO20000'
      },
      {
        'text': 'FALINK网关',
        'value': 'FALK0000'
      },
      {
        'text': 'JAGA定制模块',
        'value': 'JAGA0360'
      },
      {
        'text': '欧版4G网关',
        'value': 'VOD00001'
      },
      {
        'text': 'JAG欧版定制模块',
        'value': 'JAG00360'
      },
      {
        'text': '通用4G模块-省流',
        'value': 'VOD10000'
      },
      {
        'text': '全球通4G网关',
        'value': 'VOD10001'
      }
      ],
      produce: {
        name: '',
        username: ''
      },
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }]
      },
      numrules: {
        type: [{ required: true, message: '请选择网关', trigger: 'change' }],
        count: [{ required: true, message: '请输入配额', trigger: 'blur' }]
      },
      numdata: [],
      where: {
        type: ''
      },
      pageset: {
        size: 15,
        index: 1
      },
      totalsize: 0,
      num: {},
      dialogFormVisible: false
    }
  },
  watch: {
    'num.type': function (val) {
      const ty = this.alltype.filter(d => { return d.value == val })
      if (ty && ty.length > 0) {
        this.num.name = ty[0].text
      } else {
        this.num.type = ''
      }
    }
  },
  mounted: function () {
    let user = window.localStorage.getItem('customer')
    if (user) {
      let self = this
      this.searchNumber()
      Vue.axios
        .post('/produce/query', {
          innerid: this.$route.params.innerid
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            self.produce = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
              type: 'error'
            })
          }
        })
    } else {
      this.$message({
        message: '无登录信息，请重新登录',
        type: 'warning'
      })
      this.$router.push({ name: 'Login' })
    }
  },
  methods: {
    saveDealer () {
      this.$refs.customerForm.validate((valid) => {
        if (valid) {
          var self = this
          Vue.axios
            .post('/produce/edit',
              self.produce
            )
            .then((res) => {
              if (res.data.errcode == 0) {
                self.$message({
                  message: '账户保存成功',
                  type: 'success'
                })
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
                  type: 'error'
                })
              }
            })
        } else {
          return false
        }
      })
    },
    indexMethod (index) {
      return (this.pageset.index - 1) * this.pageset.size + index + 1
    },
    handleSizeChange (val) {
      this.pageset.size = val
      this.searchNumber()
    },
    handleCurrentChange (val) {
      this.pageset.index = val
      this.searchNumber()
    },
    searchNumber () {
      let self = this
      Vue.axios
        .post('/produce/num/list', {
          produceid: this.$route.params.innerid,
          where: self.where,
          pageset: self.pageset
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            self.numdata = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
              type: 'error'
            })
          }
        })
      Vue.axios
        .post('/produce/num/count', {
          produceid: this.$route.params.innerid,
          where: self.where
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            self.totalsize = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
              type: 'error'
            })
          }
        })
    },
    back () {
      this.$router.back()
    },
    newNum () {
      this.num = {
        type: '',
        name: '',
        produceid: this.$route.params.innerid,
        count: 0
      }
      this.dialogFormVisible = true
    },
    deleteNum (row) {
      if (row.reset) {
        this.$message({
          showClose: true,
          message: '已经预生成网关，尚未生产，无法删除',
          type: 'error'
        })
        return
      }
      this.$confirm(
        '未使用的序列号将被浪费，确定删除配额' + row.name + '？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          var self = this
          let url = '/produce/num/del'
          Vue.axios
            .post(url, {
              innerid: row.innerid
            })
            .then((res) => {
              if (res.data.errcode == 0) {
                self.$message({
                  type: 'success',
                  message: '删除成功!'
                })
                self.searchNumber()
              } else {
                self.$message({
                  showClose: true,
                  message:
                    res.data.errmsg || '发生未知错误，请联系相关人员查看',
                  type: 'error'
                })
              }
            })
        })
        .catch(() => {})
    },
    saveNum () {
      this.$refs.numForm.validate((valid) => {
        if (valid) {
          var self = this
          // debugger;
          Vue.axios
            .post('/produce/num/add',
              self.num
            )
            .then((res) => {
              if (res.data.errcode == 0) {
                self.$message({
                  message: '新增配额成功',
                  type: 'success'
                })
                self.dialogFormVisible = false
                self.searchNumber()
              } else {
                this.$message({
                  showClose: true,
                  message: '保存失败',
                  type: 'error'
                })
              }
            })
        } else {
          return false
        }
      })
    },
    ready (row) {
      this.$confirm(
        '确定将剩余未使用配额预生成网关信息？这将会改变生产流程。',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          var self = this
          let url = '/produce/num/ready'
          Vue.axios
            .post(url, {
              innerid: row.innerid,
              produceid:this.$route.params.innerid

            })
            .then((res) => {
              if (res.data.errcode == 0) {
                self.$message({
                  type: 'success',
                  message: '生成成功!'
                })
                self.searchNumber()
              } else {
                self.$message({
                  showClose: true,
                  message:
                    res.data.errmsg || '发生未知错误，请联系相关人员查看',
                  type: 'error'
                })
              }
            })
        })
        .catch(() => {})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.el-collapse-item__wrap,
.el-collapse-item__header
{
background: #F2F2F6;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .el-upload-list--picture-card .el-upload-list__item {
     width: 100px;
  height: 100px;
    line-height: 100px;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
   width: 100px;
  height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
   width: 100px;
  height: 100px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/Produce/Edit.vue